export default __webpack_public_path__ + "static/media/img-0101-china-premium-face.616641b1.png";